import React from "react"
import {
  Box,
  Card,
  CardContent,
  Button,
  Typography,
  Divider,
  Hidden,
} from "@material-ui/core"
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles"
import { useSelector } from "react-redux"
import Layout from "../Layout"
import zhutravelTheme from "../Layout/zhutravelTheme"
import LocalizedLink from "../LocalizedLink"
import CustomTourInfoBox from "./CustomTourInfoBox"

const mapTheme = createMuiTheme(zhutravelTheme, {
  palette: {
    secondary: {
      main: "#FF9486",
      contrastText: "#010204",
      dark: "#ff715f",
    },
  },
  overrides: {
    MuiTypography: {
      overline: {
        display: "block",
        marginTop: zhutravelTheme.spacing(4),
        fontFamily: "MabryProLight",
      },
    },
    MuiCardContent: {
      root: {
        padding: zhutravelTheme.spacing(3),
      },
    },
    MuiFormControl: {
      root: {
        marginTop: zhutravelTheme.spacing(4),
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: "0.875rem",
      },
    },
    MuiInputLabel: {
      shrink: {
        transform: "translate(0, 0)",
      },
    },
    MuiListItem: {
      dense: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
})

const useStyles = makeStyles(theme => ({
  cardStyle: {
    margin: theme.spacing(2),
    width: "100%",
  },
  logo: {
    fontFamily: "MabryProBold",
    fontSize: "1.5rem",
    fontWeight: "bold",
    padding: 0,
    lineHeight: "24px",
  },
  pgNumStyle: {
    fontSize: "2rem",
    lineHeight: "32px",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "calc(100vh - 32px)",
  },
}))

const CustomTourContainer = ({
  pgNum,
  pageContext,
  location,
  contactInfo,
  buttonProps,
  showReqs,
  children,
}) => {
  const classes = useStyles()
  const translations = useSelector(
    state => state?.locale?.localeObj?.pageData?.mapScreen
  )

  const itineraryData = location?.state?.itineraryData
    ? location.state.itineraryData
    : null
  const reqsData = location?.state?.reqsData ? location.state.reqsData : null

  const CustomTourSidebar = () => {
    return (
      <>
        <Box display="flex" justifyContent="space-between" mb={4}>
          <Button
            component={LocalizedLink}
            to="/"
            disableRipple
            className={classes.logo}
          >
            {translations?.zhutravel}
          </Button>
          <Typography className={classes.pgNumStyle}>
            {pgNum}&frasl;3
          </Typography>
        </Box>
        <Typography variant="overline" style={{ fontFamily: "MabryProLight" }}>
          {translations?.customTour}
        </Typography>
        <Typography variant="h6">{translations?.createCustomTour}</Typography>
        <CustomTourInfoBox
          itineraryData={itineraryData}
          translations={translations}
          showReqs={showReqs}
          reqsData={showReqs ? reqsData : null}
        />
      </>
    )
  }
  return (
    <Layout isHeaderDisable pageContext={pageContext} location={location}>
      <ThemeProvider theme={mapTheme}>
        <Box display="flex" style={{ backgroundColor: "#faf5ef" }}>
          <Card className={classes.cardStyle}>
            <CardContent className={classes.cardContent}>
              <Box display="flex" mb={10}>
                <Hidden smDown>
                  <Box width={1 / 4} mr={3}>
                    <CustomTourSidebar />
                  </Box>
                  <Divider orientation="vertical" flexItem />
                  <Box width={3 / 4} mt={10}>
                    {children}
                  </Box>
                </Hidden>
                <Hidden mdUp>
                  <Box width={1} mt={5}>
                    {children}
                  </Box>
                </Hidden>
              </Box>
              <Box>
                <Divider />
                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <Button
                    variant="outlined"
                    component={LocalizedLink}
                    to={buttonProps.back}
                    state={buttonProps.state}
                  >
                    {translations?.back}
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    component={LocalizedLink}
                    style={{ marginLeft: "16px" }}
                    to={buttonProps.to}
                    state={buttonProps.state}
                  >
                    {translations?.confirm}
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </ThemeProvider>
    </Layout>
  )
}

export default CustomTourContainer
